<template>
  <div style="display: flex;">
    <div class="left">
      <!-- <i class="iconfont icon-shouye" @click="gohome" v-if="lineStatus" style="color:#525C66"></i>  -->
      <img class="item" @click="gohome" v-if="lineStatus" src="./assets/head/home.svg">
      <img class="item" @click="reload" v-if="checkAppState() == 'operate' && lineStatus" style="margin: 6px 0 0 8px;"
        src="./assets/head/return.svg">
    </div>
    <div class="home-right">

      <Head />
    </div>
    <div class="app">
      <el-dialog v-model="downloadFail" width="50%" :before-close="handleClose">
        <!-- <span>{{$t(`message.downloadNetError`)}}</span> -->
        <div class="tip">
          <p class="tipTop">{{ $t(`message.DownloadErrorToast`) }}</p>
          <p class="tipP">{{ $t(`message.DownloadErrorToast1`) }}</p>
          <p class="tipP">{{ $t(`message.DownloadErrorToast2`) }}</p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="downloadFail = false">{{ $t(`message.OK`) }}</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
  <div v-if="!lineStatus">
    <outlinenet class="fun-area-wrap fun-area-wrap-border" />
  </div>
  <router-view v-if="lineStatus"></router-view>
</template>
<script>
import { dateFormat } from "@/utils/format.js";
import FingerprintJS from '@fingerprintjs/fingerprintjs'
import moment from "moment";
import Menu from './components/pc/menu.vue'
import Head from './components/pc/head.vue'
import Function from './components/pc/function.vue'
import Login from './components/login/index.vue'
import loading from './components/common/loading.vue'
import failConvert from "./components/common/failConvert.vue";
import outlinenet from "./components/common/outlinenet.vue";
import { gaEvent } from "@/utils/gaEvent";
const schedule = require('node-schedule')
const electron = window.electron;
export default {
  name: 'App',
  data() {
    return {
      radio: '1',
      langShow: '',
      showTop: false,
      percent: 0,
      show: false,
      lineStatus: true,
      processNowTime: '',
      downloadFail: false
    }
  },
  computed: {
    getAppStore() {
      return this.$store.state.appState
    }
  },
  methods: {
    reload() {
      const _this = this
      // if (_this.checkAppState() != "start" && _this.checkAppState() != "failConvert" && _this.checkAppState() != "failUpload") {
      if (_this.checkAppState() == "converting") {
        console.log("------", _this.checkAppState());
        this.$confirm(this.$t(`message.commonTip.alertTip[5].poptext`), {
          confirmButtonText: this.$t(`message.commonTip.alertTip[5].confirmButtonText`),
          cancelButtonText: this.$t(`message.commonTip.alertTip[5].cancelButtonText`),
          type: "none",
          closeOnClickModal: false
        })
          .then(() => {
            window.location.reload()
          })
          .catch(() => {
          });
      } else {
        window.location.reload()
      }
    },
    checkAppState() {
      return this.$store.state.appState;
    },
    getPdfToken() {
      // //console.log("wahahah");
      this.$http
        .postGetToken('/app/getToken')
        .then((responst) => {
          this.$cookies.set('pdfToken', responst.data)
          this.$store.commit('changePdfToken', responst.data)
        })
        .catch(() => {
          var timer = setInterval(() => {
            clearImmediate(timer)
            this.getPdfToken()
          }, 3000)
        })
    },
    backToTop() {
      document.documentElement.scrollTop = 0
    },
    handleClose(done) {
      this.downloadFail = false
    },
    //检查
    checkUpdate() {
      console.log('---===-=-=-=checkUpdate');
      // //监听
      electron.ipcRenderer.on('send-message-to-render-test', (event, arg) => {
        console.log('启动:', arg)
        setTimeout(() => {
          gaEvent.event("start", {
            event_category: "CrashRate",
            event_label: "null",
          });
        }, 4000)
        this.$store.commit('changeCurrentPage', 'home')
        if (arg) {
          localStorage.setItem('pcusername', arg.username)
          localStorage.setItem('userInfoPc', arg.userInfoPc)
        }
      })
      // electron.ipcRenderer.on('send-message-end', (event, arg) => {
      //   console.log('关闭:', arg)
      //   this.$gtag.event("end", {
      //     event_category: "CrashRate",
      //     event_label: "null",
      //   });
      // })
      const version = '1.0.1.0'
      const Country = sessionStorage.getItem('area')
      const userIdentity = localStorage.getItem('userIdentity')
      console.log("window:", this.$gtag);
      console.log("window:", window);
      // let gtag = this.$gtag
      electron.ipcRenderer.send('info', {
        version: version,
        Country: Country,
        userIdentity: userIdentity,
        _gid: this.$cookies.get('_gid'),
        _ga: this.$cookies.get('_ga')
        // window: gtag
      })
      // electron.ipcRenderer.on('auto-updater', (event, arg) => {
      //   console.log('更新:', arg)
      // })
    },
    gohome() {
      console.log("回首页:", this.$store.state.navName);
      const _this = this
      // if (_this.checkAppState() != "start" && _this.checkAppState() != "failConvert" && _this.checkAppState() != "failUpload" && _this.checkAppState() != "converted") {
      if (_this.checkAppState() == "converting") {
        console.log("------", _this.checkAppState());
        this.$confirm(this.$t(`message.commonTip.alertTip[5].poptext`), {
          confirmButtonText: this.$t(`message.commonTip.alertTip[5].confirmButtonText`),
          cancelButtonText: this.$t(`message.commonTip.alertTip[5].cancelButtonText`),
          type: "none",
          closeOnClickModal: false
        })
          .then(() => {
            let covertTime = Math.floor((new Date().getTime() - _this.$store.state.processTime) / 1000)
            _this.$gtag.event("process_giveup", {
              event_category: _this.$store.state.navName,
              event_label: covertTime
            });
            window.location.href = this.$store.state.locationUrl + '/pc-home'
            this.$store.commit('changeCurrentPage', 'home')

          })
          .catch(() => {
          });
      } else {
        window.location.href = this.$store.state.locationUrl + '/pc-home'
        this.$store.commit('changeCurrentPage', 'home')

      }

      // this.$router.push('/')
    },
    getUserInfo() {
      console.log("定时器", localStorage.getItem("authorization"));
      if (localStorage.getItem("authorization")) {
        console.log("获取信息");
        this.$http
          .get('/app/user/profile')
          .then(async (res) => {
            console.log("res:", res);
            if (res.code == 200) {
              console.log("200:", res.code == 200);

              res.data.expired_time = dateFormat(res.data.vip_expired_time)
              console.log("=====");
              res.data.count = res.data.total_count - res.data.used_count
              console.log("????");
              // this.$store.state.userInfo = res.data
              this.$store.commit('getUserInfo', res.data)
              console.log("!!!");
              let time = Math.round(new Date().valueOf() / 1000)
              console.log("res.data.vip_expired_time:", res.data.vip_expired_time, time);
              if (res.data.vip_expired_time < time || !res.data.vip_expired_time) {
                this.$store.commit('changeIsShowPur', true)
              }
              console.log("Pcmoment:", dateFormat(res.data.vip_expired_time));
            }
          })
          .catch(() => {
            console.log("断网了");
            this.isnetwork = true
          })
      }
    },
    getCount() {
      this.$http
        .get('/app/user/opt-count')
        .then((res) => {
          if (res.code == 200) {
            this.$store.commit('changeOptCount', res.data)
          }
        })
        .catch((err) => {
        });
    }
  },
  watch: {},
  components: {
    Menu,
    Login,
    Head,
    Function,
    failConvert,
    loading,
    outlinenet
  },
  mounted() {
    console.log("=================================测试版本======================================");
    schedule.scheduleJob("1", '0 0 0 * * *', () => {
      // 具体任务内容....
      try {
        this.getUserInfo()
      } catch (error) {
      }
    })

    console.log("123123");
    this.processNowTime = Math.round(new Date().valueOf() / 1000)
    this.checkUpdate()
    //获取设备唯一id
    if (!localStorage.getItem('deviceId')) {
      FingerprintJS.load().then(fp => {
        fp.get().then(result => {
          this.$store.commit('setDeviceId', result.visitorId)
          localStorage.setItem('deviceId', result.visitorId)
          console.log('获取设备唯一标识：', result.visitorId);
        });
      });
    }
    //pdftoken
    this.$store.commit('changeStateMenuIndex', 0)
    this.$cookies.isKey('pdfToken') ? this.$store.commit('changePdfToken', this.$cookies.get('pdfToken')) : this.getPdfToken()
    let myDate = dateFormat(Math.round(new Date().valueOf() / 1000))

    // this.checkUpdate()

    let userden
    if (this.$store.state.userInfo.email == '') {
      userden = 'visitor' //游客
      this.$store.commit("changeUserIdentity", 'guest')
      localStorage.setItem('userIdentity', 'guest')
      console.log("游客");
    } else if (this.$store.state.userInfo.user_created_time == this.$store.state.userInfo.vip_expired_time) {
      userden = 'free' //没花过钱的
      this.$store.commit("changeUserIdentity", 'general_user')
      localStorage.setItem('userIdentity', 'general_user')
      console.log("免费");
    } else if (this.$store.state.userInfo.vip_expired_time < this.processNowTime) {
      userden = 'expired' //过期的
      this.$store.commit("changeUserIdentity", 'general_user')
      localStorage.setItem('userIdentity', 'general_user')
      console.log("过期的");
    } else {
      userden = 'member' //会员
      this.$store.commit("changeUserIdentity", 'member')
      localStorage.setItem('userIdentity', 'member')
      console.log("会员");

    }
    //每日第一次
    if (localStorage.getItem("user_views") && localStorage.getItem("user_views") != myDate) {
      // this.$gtag.event("user", {
      gaEvent("user", {
        event_category: "Login_Register",
        event_label: userden,
      });
      if (userden == "member") {
        let memberY = this.$store.state.userInfo.vip_difference == 1 ? 'month' : (this.$store.state.userInfo.vip_difference == 2 ? 'quarter' : 'year')
        // this.$gtag.event("member", {
        gaEvent("member", {
          event_category: "Login_Register",
          event_label: memberY,
        });
      }
      localStorage.setItem("user_views", myDate)
    } else if (!localStorage.getItem("user_views")) {
      // localStorage.setItem('userIdentity', 'guest')

      localStorage.setItem("user_views", myDate)
      // this.$gtag.event("user_views", {
      //   event_category: "pageviews",
      //   event_label: "new",
      // });
      gaEvent("user", {
        event_category: "Login_Register",
        event_label: "visitor",
      });
    }
    this.$store.commit('changeStateLocationHref', window.location.href)
    this.offlineF = () => {
      console.log("------------========error");
      this.lineStatus = false
    };
    this.onlineF = () => {
      console.log("online");
      this.lineStatus = true
      window.location.reload()
    };
    window.addEventListener("offline", this.offlineF);
    window.addEventListener("online", this.onlineF);
  },

  created() {
    this.getCount()
  },
  beforeDestory() {
    console.log("销毁=11111");
    this.$gtag.event("asd", {
      event_category: this.$store.state.currentPage,
      event_label: "null"
    });
  },
  destoryed() {
    // window.removeEventListener('beforeunload', (e) => this.beforeunloadFn(e))
    console.log("销毁=");
    this.$gtag.event("asd", {
      event_category: this.$store.state.currentPage,
      event_label: "null"
    });
  }
}
</script>

<style lang="scss" scoped>
.item {
  cursor: pointer;
  margin-top: 6px;
  border-radius: 6px;

  &:hover {
    /* content: url(../../assets/head/minimizeh.svg); */
    background-color: #ECECFF;
  }

  &:active {
    /* content: url(../../assets/head/minimizea.svg); */
    background-color: #DDDCFD;

  }
}

.tip {
  margin-top: 50px;
  width: 554px;

  .tipTop {
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    color: rgba(29, 29, 31, 0.7);
    margin-bottom: 8px;
  }

  .tipP {
    margin-top: 3px;
    font-family: 'Microsoft YaHei';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    color: rgba(29, 29, 31, 0.5);
  }
}

.home {
  width: 1224px;
  /* height: 592px; */
  display: flex;
}

.left {
  width: 220px;
  height: 44px;
  background: #EEF5FF;
  padding: 0px 0 0px 24px;

  i {
    margin-right: 2px;
    cursor: pointer;
    font-size: 32px;

    &:hover {
      color: #4260FF;
    }

    &:active {
      color: #3432D6;
    }
  }
}

.home-left {
  /* width: 220px; */
  /* height: 592px; */
  background: #F5F7FD;
  /* background-image: url(./assets/menu/back.svg); */

  .left-menu {
    margin-top: 68px;
  }
}

.home-right {
  width: 1004px;
  /* height: 592px; */
  /* margin-left: 220px; */
  display: flex;
  flex-direction: column;
}
</style>
<style lang="scss" scope>
img {
  -webkit-user-drag: none;
}

.alertSpan {
  margin-left: 12px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;

  color: rgba(29, 29, 31, 0.7);
}

.cancleBtn {
  display: none !important;
}

#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  /* font-family: 'Be Vietnam Pro', sans-serif; */
  color: #001637;

  h2 {
    margin: 0;
  }

  ul {
    margin: 0;
    padding: 0;
  }
}

.show {
  display: none !important;
}

.active {
  display: block !important;
}

.el-backtop {
  background-color: rgb(0, 0, 0, 0) !important;
  box-shadow: none !important;
  bottom: 45px !important;
  right: 12px !important;
  z-index: 10 !important;
}

.footer a:hover {
  color: #fff !important;
  text-decoration: underline;
}

p {
  margin-bottom: 0;
}

li {
  list-style-type: none;
}

.flexible {
  display: flex;
}

.flex-justify-between {
  justify-content: space-between;
}

.flex-wrap {
  flex-wrap: wrap;
}

#fun-area {
  padding-top: 64px;
  /* // padding-bottom: 80px; */
  background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTkyMCIgaGVpZ2h0PSI1NjgiIHZpZXdCb3g9IjAgMCAxOTIwIDU2OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjE5MjAiIGhlaWdodD0iNTY4IiBmaWxsPSIjRjVGN0ZEIi8+CjxtYXNrIGlkPSJtYXNrMF81ODgwXzQ4ODIiIHN0eWxlPSJtYXNrLXR5cGU6YWxwaGEiIG1hc2tVbml0cz0idXNlclNwYWNlT25Vc2UiIHg9IjAiIHk9IjAiIHdpZHRoPSIxOTIwIiBoZWlnaHQ9IjU2OCI+CjxyZWN0IHdpZHRoPSIxOTIwIiBoZWlnaHQ9IjU2OCIgZmlsbD0iI0Y1RjdGRCIvPgo8L21hc2s+CjxnIG1hc2s9InVybCgjbWFzazBfNTg4MF80ODgyKSI+CjxnIG9wYWNpdHk9IjAuNCIgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZl81ODgwXzQ4ODIpIj4KPGVsbGlwc2UgY3g9IjE1NzIuMzQiIGN5PSItNzEuODQ2NiIgcng9IjQ4NC41IiByeT0iMjI5LjUiIHRyYW5zZm9ybT0icm90YXRlKDkuNzM5MzQgMTU3Mi4zNCAtNzEuODQ2NikiIGZpbGw9IiMyNzhCRkYiLz4KPC9nPgo8ZyBvcGFjaXR5PSIwLjQiIGZpbHRlcj0idXJsKCNmaWx0ZXIxX2ZfNTg4MF80ODgyKSI+CjxlbGxpcHNlIGN4PSIzNjIuMzg3IiBjeT0iNzQwLjYxNSIgcng9IjQ0MC41IiByeT0iMjA4LjUiIHRyYW5zZm9ybT0icm90YXRlKDEyLjYwNjcgMzYyLjM4NyA3NDAuNjE1KSIgZmlsbD0iI0U5NDg0OCIvPgo8L2c+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTMzNi4zOSAtMjU1LjUxOEMxMTY5Ljk3IC0xOS40ODc3IDk5OC41MDEgMTIyLjk3MyA4MzMuMDE2IDEyOC42NzlDODU1LjgxMSAxNTguNDE3IDg3Ni4yNTYgMTg1LjkyNyA4OTUuMDQ5IDIxMS4yMTNDMTA2Ny4wNiA0NDIuNjU0IDExMDAuNTYgNDg3LjcyNiAxNTI4LjgyIDM0OS4zOTNDMTczMi44NCAyODMuNDk2IDE5ODIuMjUgNTQuMDg2NyAyMjIxLjMyIC0yNTUuNTE4TDEzMzYuMzkgLTI1NS41MThaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfNTg4MF80ODgyKSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTEyODIuNDggLTUyNC41MzlDMTEzMC4wMiAtMTY4LjkgOTYyLjAzNCA3NC41ODE0IDc5Mi4xMzcgMTM2Ljg3NkM3OTcuMjM1IDE0Mi4xMDcgODAyLjMxMiAxNDcuMzIyIDgwNy4zNyAxNTIuNTE3QzEwNTUuMjggNDA3LjE1NCAxMjU3LjgxIDYxNS4xOTIgMTU2OS4zNCAzMzMuMDc2QzE3MzMuODEgMTg0LjEzNiAxOTMxLjYgLTEzOS40NjggMjExNy43IC01MjQuNTM5TDEyODIuNDggLTUyNC41MzlaIiBmaWxsPSJ1cmwoI3BhaW50MV9saW5lYXJfNTg4MF80ODgyKSIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTS0yNiAtNi44Mzc3QzI2My4xNTMgNDM4LjQ1NSA1MzkuODA3IDYwMS4xNzUgMTAzMi44NCA1NTYuNzdDMTAzNi42MiA1NTYuNDMgMTA0MS42NyA1NTYuMTQ0IDEwNDcuOSA1NTUuNzkzQzExMTguNTIgNTUxLjgwNyAxMzM5Ljk2IDUzOS4zMDcgMTU2My41NyAzNDEuMjIxQzExMjYuNzUgNDAyLjYyOSA5MjIuMzgxIDI2Ni40NTEgNzYzLjk3NiAtNi44Mzc4M0wtMjYgLTYuODM3N1oiIGZpbGw9InVybCgjcGFpbnQyX2xpbmVhcl81ODgwXzQ4ODIpIi8+CjwvZz4KPGRlZnM+CjxmaWx0ZXIgaWQ9ImZpbHRlcjBfZl81ODgwXzQ4ODIiIHg9IjU2MS4yMjIiIHk9Ii04NDQuNDk2IiB3aWR0aD0iMjAyMi4yNCIgaGVpZ2h0PSIxNTQ1LjMiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMjY2IiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfNTg4MF80ODgyIi8+CjwvZmlsdGVyPgo8ZmlsdGVyIGlkPSJmaWx0ZXIxX2ZfNTg4MF80ODgyIiB4PSItNjAxLjkzMSIgeT0iLTE2LjQ4MTMiIHdpZHRoPSIxOTI4LjYzIiBoZWlnaHQ9IjE1MTQuMTkiIGZpbHRlclVuaXRzPSJ1c2VyU3BhY2VPblVzZSIgY29sb3ItaW50ZXJwb2xhdGlvbi1maWx0ZXJzPSJzUkdCIj4KPGZlRmxvb2QgZmxvb2Qtb3BhY2l0eT0iMCIgcmVzdWx0PSJCYWNrZ3JvdW5kSW1hZ2VGaXgiLz4KPGZlQmxlbmQgbW9kZT0ibm9ybWFsIiBpbj0iU291cmNlR3JhcGhpYyIgaW4yPSJCYWNrZ3JvdW5kSW1hZ2VGaXgiIHJlc3VsdD0ic2hhcGUiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMjY2IiByZXN1bHQ9ImVmZmVjdDFfZm9yZWdyb3VuZEJsdXJfNTg4MF80ODgyIi8+CjwvZmlsdGVyPgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MF9saW5lYXJfNTg4MF80ODgyIiB4MT0iMTc1MiIgeTE9IjMyNi41IiB4Mj0iMTQzMy4yMSIgeTI9IjIyMy44NzMiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0id2hpdGUiIHN0b3Atb3BhY2l0eT0iMC4yIi8+CjxzdG9wIG9mZnNldD0iMSIgc3RvcC1jb2xvcj0iI0Q4RTlGRiIvPgo8L2xpbmVhckdyYWRpZW50Pgo8bGluZWFyR3JhZGllbnQgaWQ9InBhaW50MV9saW5lYXJfNTg4MF80ODgyIiB4MT0iMTU2MiIgeTE9Ii0xMDMuNSIgeDI9IjkwMC44MDYiIHkyPSI0ODIuMzk2IiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IiNGMkY3RkYiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSIjRUFGM0ZGIi8+CjwvbGluZWFyR3JhZGllbnQ+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQyX2xpbmVhcl81ODgwXzQ4ODIiIHgxPSI0OTkiIHkxPSI2My41IiB4Mj0iNTUzIiB5Mj0iMjYxIiBncmFkaWVudFVuaXRzPSJ1c2VyU3BhY2VPblVzZSI+CjxzdG9wIHN0b3AtY29sb3I9IndoaXRlIiBzdG9wLW9wYWNpdHk9IjAiLz4KPHN0b3Agb2Zmc2V0PSIxIiBzdG9wLWNvbG9yPSJ3aGl0ZSIgc3RvcC1vcGFjaXR5PSIwLjQiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K');
  background-size: cover;
  height: 568px;

  .editBox {
    max-width: 1224px;
    margin: 72px auto auto auto;
    position: relative;
    height: 548px;
    display: flex;
    box-shadow: 0px 10px 16px rgb(84 82 246 / 8%);
    border-radius: 16px;
  }
}

#fun-area.showTop {
  padding-top: 100px;
}

.fun-area-wrap {
  width: 100%;

  .el-upload,
  .upload-area,
  .grid-content {
    height: 100%;
  }

  .el-upload,
  .el-upload-dragger {
    /* width: 100%; */
    width: 1176px;
    height: 500px;
  }

  .upload-area {
    .el-upload {
      .el-upload-dragger {
        height: 100%;
        /* padding: 24px; */
        padding-top: 40px;
        border: 2px dashed #eaeaea;
        border-radius: 12px;

        &:hover {
          border: 2px dashed #cccbfc;
        }

        &:active {
          border: 2px dashed #cccbfc;
        }

        &:focus {
          border: 2px dashed #5452f6;
          background-color: red;
        }
      }
    }
  }
}

.changehome {
  cursor: pointer;
  margin-top: 6px;

  &:hover {
    content: url(./assets/head/homeh.svg);
  }

  &:active {
    content: url(./assets/head/homea.svg);
  }
}

.changereturn {
  cursor: pointer;
  margin: 6px 0 0 8px;

  &:hover {
    content: url(./assets/head/returnh.svg);
  }

  &:active {
    content: url(./assets/head/returna.svg);
  }
}
</style>
<style lang="scss">
.app .el-dialog {
  margin-top: 28vh !important;
  border-radius: 8px;
}

.app .el-dialog__body {
  padding: 0px 20px 16px 20px
}

.app .el-dialog__header {
  padding-bottom: 0px !important;
}

.app .dialog-footer {
  display: flex;
  justify-content: right;
  margin-top: 24px;
}

.app .el-button--primary {
  background: #5452F6 !important;
  width: 110px;
  height: 32px;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #FFFFFF;
  border-radius: 40px;

  &:hover {
    background: #3E3BFF !important;
    color: white;
    box-shadow: 0px 5px 8px rgba(84, 82, 246, 0.3);
  }

  &:active {
    background: #3432D6 !important;
    color: white;
    box-shadow: 0px 5px 8px rgba(84, 82, 246, 0.3);
  }
}
</style>
